export const buildAttorneyValues = (caseDetail) => ({
  lawyerSettlementAmount:
    caseDetail?.lawyerSettlementAmount ?? caseDetail?.lawyer_settlement_amount ?? "",
  lawyerSettlementCosts:
    caseDetail?.lawyerSettlementCosts ?? caseDetail?.lawyer_settlement_costs ?? "",
});

export const buildAttorneyPayload = (formValues) => ({
  lawyer_settlement_amount: formValues.lawyerSettlementAmount || null,
  lawyer_settlement_costs: formValues.lawyerSettlementCosts || null,
});

export const isAttorneyDirty = (formValues, initialValues) =>
  formValues.lawyerSettlementAmount !== initialValues.lawyerSettlementAmount ||
  formValues.lawyerSettlementCosts !== initialValues.lawyerSettlementCosts;

const parseCurrencyValue = (value) => {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  const normalizedValue = Number.parseFloat(String(value).replace(/[^\d.]/g, ""));

  return Number.isNaN(normalizedValue) ? null : normalizedValue;
};

export const getAttorneyTotalReduction = (formValues, caseDetail) => {
  const feeAmount = parseCurrencyValue(formValues?.lawyerSettlementAmount);
  const costAmount = parseCurrencyValue(formValues?.lawyerSettlementCosts);

  if (feeAmount !== null || costAmount !== null) {
    const total = (feeAmount || 0) + (costAmount || 0);

    return total ? total.toFixed(2) : "";
  }

  return caseDetail?.lawyerTotalCosts ?? caseDetail?.lawyer_total_costs ?? "";
};
